/*====================================================
    MODULE: ACCORDION
====================================================*/ 
$('.l-filter').click(function() {
  const dataTag = $(this).attr('data-tag');

  if ($('.l-filter').hasClass('active')) {
    $('.l-filter').removeClass('active').removeAttr('style');
  }

  if ($('.docs-list-item').show()) {
    $('.docs-list-item').hide();
  }

  $('.l-filter-'+dataTag).addClass('active').css({
    'background-color': $(this).attr('data-color'),
    'color': 'white'
  });

  $('.docs-list-item[data-tag = '+dataTag+']').show();
});


$('.l-filter-clear').click(function() {
  if ($('.l-filter').hasClass('active')) {
    $('.l-filter').removeClass('active').removeAttr('style');
  }
  
  if ($('.docs-list-item').hide()) {
    $('.docs-list-item').show();
  }
});